<p>user-view-and-edit works!</p>
